export const SALE_CREATE_FORM_ID = Symbol();
